module.exports = __webpack_public_path__ + "static/style-060c8de0332ac74a6d3700511a506e4a.png";